import { ShareLinkSheet } from './ShareLinkSheet.tsx';
import { api } from '../../api/client.ts';

type Props = { open: boolean; onClose: () => void };

export function DeviceLinkSheet({ open, onClose }: Props) {
  return (
    <ShareLinkSheet
      open={open}
      onClose={onClose}
      title="Add another device"
      tagline="Scan with your other phone, or copy the link."
      shareTitle="Lion Tracker"
      shareText="Sign in to Lion Tracker on this device"
      generate={() =>
        api<{ url: string; expires_at: number }>('/api/auth/new-device-link', {
          method: 'POST',
          json: {},
        })
      }
      caption="Single use · expires in 1 hour"
    />
  );
}
